import { Cell } from '../cells';
import { OrderNumberColumn } from '../columns/index';

/**
 * Header cell for execution number.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function HeaderExecutionOrderCell() {
  return (
    <OrderNumberColumn isHeader>
      <Cell>#</Cell>
    </OrderNumberColumn>
  );
}
